export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/IS LIVE.a1e755ec.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};